<template>
  <el-dialog title="배너 추가" :visible="visible" width="640px" @close="$emit('update:visible', false)">
    <div v-if="loading" class="ebsm-empty">불러오는 중...</div>
    <div v-else-if="banners.length === 0" class="ebsm-empty">불러올 배너가 없습니다.</div>
    <el-checkbox-group v-else v-model="selectedIds" class="ebsm-list">
      <label v-for="b in banners" :key="b.bannerId" class="ebsm-item">
        <el-checkbox :label="b.bannerId"><span /></el-checkbox>
        <div class="ebsm-thumb" :class="'ebsm-thumb--' + thumbClass">
          <img v-if="b.imageFileId" :src="imageUrl(b.imageFileId)" :alt="b.title" />
          <div v-else class="ebsm-thumb-empty"></div>
        </div>
        <div class="ebsm-info">
          <span class="ebsm-title">{{ b.title || "(제목 없음)" }}</span>
          <span class="ebsm-period">{{ formatPeriod(b) }}</span>
        </div>
      </label>
    </el-checkbox-group>

    <span slot="footer" class="dialog-footer">
      <base-button type="default" @click="$emit('update:visible', false)">취소</base-button>
      <base-button type="success" :disabled="selectedIds.length === 0" @click="onConfirm">
        추가 ({{ selectedIds.length }})
      </base-button>
    </span>
  </el-dialog>
</template>

<script>
import { BaseButton } from "@/components/index";
import { formatDateTime } from "@/util/DateUtils";

export default {
  components: { BaseButton },
  props: {
    visible: { type: Boolean, default: false },
    unitId: { type: Number, default: null },
    layoutType: { type: String, default: null },
  },
  data() {
    return {
      loading: false,
      banners: [],
      selectedIds: [],
    };
  },
  computed: {
    thumbClass() {
      return (this.layoutType || "SQUARE").toLowerCase();
    },
  },
  watch: {
    visible(val) {
      if (val) this.load();
    },
  },
  methods: {
    async load() {
      this.loading = true;
      this.selectedIds = [];
      try {
        const res = await this.$axios.get("/eventBanner", { params: { unitId: this.unitId } });
        this.banners = res.data.data || [];
      } finally {
        this.loading = false;
      }
    },
    onConfirm() {
      const selected = this.banners.filter((b) => this.selectedIds.includes(b.bannerId));
      this.$emit("select", selected);
      this.$emit("update:visible", false);
    },
    imageUrl(fileId) {
      return window.Endpoints.imageServerUrl + fileId;
    },
    formatPeriod(banner) {
      if (!banner.startTime && !banner.endTime) return "-";
      const start = banner.startTime ? formatDateTime(banner.startTime) : "?";
      const end = banner.endTime ? formatDateTime(banner.endTime) : "?";
      return `${start} ~ ${end}`;
    },
  },
};
</script>

<style scoped lang="scss">
.ebsm-empty {
  padding: 40px 0;
  color: #8898aa;
  text-align: center;
}

.ebsm-list {
  display: flex;
  flex-direction: column;
  max-height: 480px;
  overflow-y: auto;
}

.ebsm-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 4px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f8f9fa;
  }
}

.ebsm-thumb {
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 4px;
  background: #f4f5f7;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &--square {
    width: 72px;
    aspect-ratio: 1 / 1;
  }

  &--horizontal {
    width: 112px;
    aspect-ratio: 95 / 53;
  }

  &--vertical {
    width: 48px;
    aspect-ratio: 380 / 539;
  }
}

.ebsm-thumb-empty {
  width: 100%;
  height: 100%;
  background: #e9ecef;
}

.ebsm-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
}

.ebsm-title {
  overflow: hidden;
  color: #32325d;
  font-size: 0.9rem;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ebsm-period {
  color: #8898aa;
  font-size: 0.75rem;
}
</style>
